import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal, NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {OfficeCoupon} from 'src/app/classes/OfficeCoupon';
import {CouponType} from 'src/app/enums/CouponType';
import {BookingOption} from 'src/app/enums/BookingOption';

@Component({
  selector: 'app-coupon-edit',
  styleUrls: ['./coupon-edit.component.scss'],
  templateUrl: './coupon-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CouponEditComponent implements OnInit {

  @Input() coupon: OfficeCoupon;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;

  types: string[];
  bookingOptions: string[];

  public minDate: NgbDateStruct;
  public couponForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private calendar: NgbCalendar) {}

  ngOnInit(): void {

    this.minDate = this.calendar.getToday();

    this.types = Object.keys(CouponType);
    this.bookingOptions = Object.keys(BookingOption);

    if (this.coupon) {
      this.couponForm = this.formBuilder.group({
        id: [this.coupon.id],
        value: [this.coupon.value, Validators.required],
        type: [this.coupon.type, Validators.required],
        bookingOption: [this.coupon.bookingOption],
        expirationDate: [this.convertDate(this.coupon.expirationDate ? new Date(this.coupon.expirationDate) : null)]
      });
    } else {
      this.couponForm = this.formBuilder.group({
        id: [null],
        value: [0, Validators.required],
        type: [CouponType.PERCENT, Validators.required],
        bookingOption: [null],
        expirationDate: [null]
      });
    }
  }

  convertDate(date: Date): NgbDateStruct {
    return date ? {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    } : null;
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
